// extracted by mini-css-extract-plugin
export default {"link":"Barrierefreiheit_link__-7vbA","title":"Barrierefreiheit_title__YTexb"};